import './Button.css';

function Button({
  children,
  onClick,
  variant = 'primary',
  type = 'button',
  disabled = false,
  loading = false,
  fullWidth = false
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`button button--${variant} ${fullWidth ? 'button--full-width' : ''}`}
    >
      {loading ? 'Processing...' : children}
    </button>
  );
}

export default Button;
